import { render, staticRenderFns } from "./UnjailMessageDetails.vue?vue&type=template&id=743104e8&"
import script from "./UnjailMessageDetails.vue?vue&type=script&lang=js&"
export * from "./UnjailMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports